import { Component } from "@angular/core";

@Component({
  selector: "success-window",
  templateUrl: "./success-window.component.html",
  styleUrls: ["./success-window.component.scss"],
})
export class RequestDemoSuccessWindowComponent {
  constructor() {}
}
